import { S } from './materialDesignIconMap.styles';

export const materialDesignIconMap = {
  'time-field-clock': { name: 'schedule' },
  'time-picker-angle-up': { name: 'expand_less' },
  'time-picker-angle-down': { name: 'expand_more' },
  'nested-checklist-expand-arrow': { name: 'expand_more', css: S.nestedChecklistExpandArrow },
  'accordion-item-arrow': { name: 'expand_more' },
  'accordion-item-plus': { name: 'add' },
  'accordion-item-minus': { name: 'remove' },
  'alert-close': { name: 'close', css: S.alertClose },
  'combo-box-delete': { name: 'close' },
  'modal-close': { name: 'close', css: S.modalClose },
  'select-down': { name: 'expand_more', css: S.selectDown },
  'switch-off': { name: 'close' },
  'switch-on': { name: 'check' },
  'collapsible-menu-submenu-arrow': { name: 'expand_more' },
  'hamburger-menu-bars': { name: 'menu' },
  'dropdown-indicator-right': { name: 'keyboard_arrow_right' },
  'dropdown-arrow-up': { name: 'expand_less' },
  'dropdown-arrow-down': { name: 'expand_more' },
  'combo-box-item-selected': { name: 'check' },
  'date-field-calendar': { name: 'calendar_today' },
  'calendar-angle-left': { name: 'keyboard_arrow_left' },
  'calendar-angle-right': { name: 'keyboard_arrow_right' },
  'combo-box-clear': { name: 'close', css: S.comboBoxClear },
  'vertical-navigation-arrow-up': { name: 'expand_less' },
  'vertical-navigation-arrow-down': { name: 'expand_more' },
  'password-field-hide': { name: 'visibility_off' },
  'password-field-show': { name: 'visibility' },
  'pdf-download': { name: 'download' },
  'file-manager-delete': { name: 'close' },
  'cmd-table-check': { name: 'check' },
  'cmd-table-link': { name: 'open_in_new' },
  print: { name: 'print' },
  'onboarding-imprint': { name: 'info' },
  'section-toggle': { name: 'expand_more' },
  'data-grid-boolean-false': { name: 'close' },
  'data-grid-boolean-true': { name: 'check' },
  'data-grid-columns': { name: 'view_column' },
  'data-grid-context-menu': { name: 'more_vert' },
  'data-grid-context-menu-hide-column': { name: 'visibility_off' },
  'data-grid-density': { name: 'format_line_spacing' },
  'data-grid-expand': { name: 'keyboard_arrow_right' },
  'data-grid-export': { name: 'download' },
  'data-grid-filter': { name: 'filter_alt' },
  'data-grid-pin-left': { name: 'push_pin' },
  'data-grid-pin-right': { name: 'push_pin' },
  'data-grid-sort-asc': { name: 'arrow_upward' },
  'data-grid-sort-desc': { name: 'arrow_downward' },
  'checkbox-check': { name: 'check' },
  'tree-graph-plus': { name: 'add' },
  'tree-graph-minus': { name: 'remove' },
  'tree-graph-fit-view': { name: 'fullscreen' },
  'tree-graph-expand': { name: 'expand_more' },
} as const;
